__turbopack_context__.v({
  "gradientBackground": "styles-module__5TEZDW__gradientBackground",
  "heading": "styles-module__5TEZDW__heading",
  "serefinContainer": "styles-module__5TEZDW__serefinContainer",
  "signUpContainer": "styles-module__5TEZDW__signUpContainer",
});
